import PSprite from './PSprite';
import PGlobal from './PGlobal';
import AudioPeaks from './component/AudioPeaks';
import AudioDataMgr from './component/AudioDataMgr';
import AudioConst from './AudioConst';

const _peaks = [];
let _invalidateWired = false;
// 同audioId音频内容变更（语音重合成等）时丢旧AudioPeaks——懒注册：
// 模块求值期PGlobal.m可能未初始化，AudioDataMgr.instance不能提前触发
function _wireInvalidate(){
    if(_invalidateWired){ return; }
    _invalidateWired = true;
    AudioDataMgr.instance.on('invalidate', (audioId)=>{
        const peaks = _peaks[audioId];
        if(peaks){
            delete _peaks[audioId];
            // 各trk已挂的load监听→dirty→重绘时_getPeaks拿新数据重建peaks
            peaks.emit('load');
            peaks.removeAllListeners('load');
        }
    });
}
export default class AudioTrk extends PSprite {
    constructor() {
        super();
        this._interval = 0;
        this.fixedH = 0;
        this._selected = false;
        this._stretchMode = false;
        this._data = null;
        this._range = null;
        this.canvas = new PIXI.Graphics();
        this.leftHaul = null;
        this.rightHaul = null;
        this.addChild(this.canvas);
    }

    set interval(value) {
        this._interval = value;
        this.dirty();
    }

    set range(range){
        this._range = range;
    }

    redraw() {
        this.canvas.clear();
        if(this._data) {
            this.fixedW = (this._data.end-this._data.start) * this._interval;
            if(this.x > this._range.max || this.x + this.fixedW < this._range.min){
                //不在显示范围内
                return;
            }
            //填充
            this.canvas.beginFill(0x4a9f95);
            this.canvas.drawRect(0, 0, this.fixedW, this.fixedH);
            this.canvas.endFill();
            //
            let peakColor = 0x47d4c4;
            let borderColor = 0x458880;
            if(this._selected) {
                peakColor = 0xFFFFFF;
                borderColor = 0xFFFFFF;
            }
            //音波
            this.drawPeaks(peakColor);
            //边框
            this.canvas.beginFill(borderColor);
            this.canvas.drawRect(0, 0, this.fixedW, 1);
            this.canvas.drawRect(0, this.fixedH - 1, this.fixedW, 1);
            this.canvas.drawRect(0, 0, 1, this.fixedH);
            this.canvas.drawRect(this.fixedW - 1, 0, 1, this.fixedH);
            this.canvas.endFill();
            //
            this._showHaul(this._stretchMode);
        }
    }

    onRemoved(){
        this._data = null;
        this._awaitPeaks = false;
        // 清理监听器，避免内存泄漏
        if(this._peaksListeners){
            for(let audioId in this._peaksListeners){
                const entry = this._peaksListeners[audioId];
                if(entry && entry.peaks){
                    entry.peaks.off("load", entry.listener);
                }
            }
            this._peaksListeners = null;
        }
    }

    set stretchMode(value) {
        if(this._stretchMode != value) {
            this._stretchMode = value;
            this.dirty();
        }
    }

    get stretchMode() {
        return this._stretchMode;
    }

    set selected(b) {
        this._selected = b;
        this.dirty();
    }

    get selected() {
        return this._selected;
    }

    set data(data) {
        this._data = data;
        this.dirty();
    }

    get data() {
        return this._data;
    }

    setHeight(value) {
        this.fixedH = value;
    }

    getWidth() {
        return this.fixedW;
    }

    _showHaul(flag){
        if(!this.leftHaul){
            const texture = PGlobal.resources.mainUI.textures['track_icon_haul'];
            this.leftHaul = new PIXI.Sprite(texture);
            this.rightHaul = new PIXI.Sprite(texture);
            const y = (this.fixedH - this.leftHaul.height) / 2 - 0.5;
            this.leftHaul.y = y;
            this.rightHaul.y = y;
            this.leftHaul.scale = {x:-1, y: 1};
        }
        window.trk = this;
        if(flag){
            this.addChild(this.leftHaul);
            this.addChild(this.rightHaul);
            const x = this.leftHaul.width / 2 - 0.5;
            this.rightHaul.x = this.getWidth() - x;
            this.leftHaul.x = x;
        } else if(this.leftHaul.parent){
            this.removeChild(this.leftHaul);
            this.removeChild(this.rightHaul);
        }
    }

    drawPeaks(fillColor){
        const data = this.data;
        if(!data){return;}
        const audioId = data.audioId;
        const peaks = this._getPeaks(audioId);
        if(!peaks){
            return;
        }

        const start = data.audioStart;
        const end = data.end - data.start + start;
        const hArray = peaks.getRangePeaks(start, end);
        const y = AudioConst.AUDIO_STEP_H;
        const hMax = AudioConst.AUDIO_STEP_H - 5;
        const graphic = this.canvas;
        //const fillColor = 0x47d4c4;
        graphic.beginFill(fillColor);
        const points = [];
        let j = 0;
        let len = hArray.length * 2 + 4;
        points[len - 1] = y;
        points[len - 2] = hArray.length - 1;

        points[j ++] = 0;
        points[j ++] = y;

        hArray.forEach((h, i)=>{
            points[j ++] = i;
            points[j ++] = y - h * hMax;
        });

        graphic.drawPolygon(points);
        graphic.endFill();
    }
    /**
     * 
     * @param {*} audioId 
     * @returns {AudioPeaks}
     */
    // onTicker每帧调（在舞台才跑）——兜底'load'事件链路：
    // peaks就绪即dirty重绘，不依赖emit/listener注册时序
    onFrame(){
        const audioId = this._data && this._data.audioId;
        if(audioId && this._awaitPeaks){
            const peaks = _peaks[audioId];
            if(peaks && peaks.loaded){
                this._awaitPeaks = false;
                this.dirty();
            }
        }
    }

    _getPeaks(audioId){
        _wireInvalidate();
        let peaks = _peaks[audioId];
        if(!peaks){
            peaks = new AudioPeaks(audioId);
            _peaks[audioId] = peaks;
        }

        // 如果还没加载完成，注册监听器（每个AudioTrk实例都需要注册）
        if(!peaks.loaded){
            // 检查是否已经为这个实例注册过监听器（记录挂在哪个peaks对象上，
            // 旧peaks被invalidate丢弃后要能在新peaks上重注册）
            if(!this._peaksListeners){
                this._peaksListeners = {};
            }
            const entry = this._peaksListeners[audioId];
            if(!entry || entry.peaks !== peaks){
                const listener = () => {
                    this.dirty();
                };
                peaks.on("load", listener);
                this._peaksListeners[audioId] = {peaks: peaks, listener: listener};
            }
            this._awaitPeaks = true;
            return null;
        }
        return peaks;
    }

}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/AudioTrk.js